import { AppModule } from 'app/module';
import { WatchlistButton } from 'module/watchlistButton/main';
import Template from './template.hbs';
import './styles.scss';

export class SuggestionListItem extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            watchlist: '.m-suggestionListItem__watchlist .m-watchlistButton',
            locationLinks: ['.m-suggestionListItem__locationLink'],
            pushedJob: '.m-suggestionListItem__labelPushedJob',
            bsLabel: '.m-suggestionListItem__bsLabel--branding',
            brandingSolutionPill: '.m-suggestionListItem__bsLabel--brandingSolution',
            logo: '.m-suggestionListItem__logo',
            titleLink: '.m-suggestionListItem__titleLink',
            companyLink: '.m-suggestionListItem__companyName',
            date: '.m-suggestionListItem__date',
        };
    }

    subs() {
        this.watchlistButton = new WatchlistButton(this.dom.watchlist);
    }

    subsProps() {
        if (this.watchlistButton) {
            this.watchlistButton.updateProps({ id: this.props.id });
        }
    }

    getPropsFromDom() {
        const locations = [];

        for (let i = 0; i < this.dom.locationLinks.length; i += 1) {
            const $location = this.dom.locationLinks[i];
            const locationProps = {
                link: $location.href,
                slug: $location.getAttribute('data-location'),
                name: $location.innerText,
                isLandingpage: !!$location.getAttribute('data-location'),
            };

            locations.push(locationProps);
        }

        return {
            id: this.dom.el.getAttribute('data-id'),
            title: this.dom.titleLink.innerHTML,
            pushedJob: !!this.dom.pushedJob,
            date: this.dom.date.innerHTML,
            company: {
                slug: this.dom.companyLink.getAttribute('data-slug'),
                name: this.dom.companyLink.innerText,
                link: this.dom.companyLink.href,
                hasBranding: this.dom.bsLabel !== null,
                isBrandingSolution: !!this.dom.brandingSolutionPill,
                logo: this.dom.logo && this.dom.logo.getAttribute('alt') ? this.dom.logo.src : false,
            },
            locations,
        };
    }
}
